import * as fromDatatype from '../datatype-library';
import { ShippingConfigJsonTypeInterface } from './shipping_config_json.model';

export interface bl_cms_website_country_hdr_RowInterface{
  guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  website_line_guid: fromDatatype.GuidDataFieldInterface;
  gps_location: fromDatatype.VarcharDatatypeInterface;
  default_currency: fromDatatype.VarcharDatatypeInterface;
  default_branch_code: fromDatatype.VarcharDatatypeInterface;
  default_branch_guid: fromDatatype.GuidDataFieldInterface;
  default_company_code: fromDatatype.VarcharDatatypeInterface;
  default_company_guid: fromDatatype.GuidDataFieldInterface;
  default_language: fromDatatype.VarcharDatatypeInterface;
  country_alpha2_code: fromDatatype.VarcharDatatypeInterface;
  country_alpha3_code: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  default_region_guid: fromDatatype.GuidDataFieldInterface;
  settlement_type: fromDatatype.VarcharDatatypeInterface;
  shipping_config_json: ShippingConfigJsonTypeInterface;
}

export class bl_cms_website_country_hdr_RowClass implements bl_cms_website_country_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  website_line_guid: fromDatatype.GuidDataFieldInterface;
  gps_location: fromDatatype.VarcharDatatypeInterface;
  default_currency: fromDatatype.VarcharDatatypeInterface;
  default_branch_code: fromDatatype.VarcharDatatypeInterface;
  default_branch_guid: fromDatatype.GuidDataFieldInterface;
  default_company_code: fromDatatype.VarcharDatatypeInterface;
  default_company_guid: fromDatatype.GuidDataFieldInterface;
  default_language: fromDatatype.VarcharDatatypeInterface;
  country_alpha2_code: fromDatatype.VarcharDatatypeInterface;
  country_alpha3_code: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  default_region_guid: fromDatatype.GuidDataFieldInterface;
  settlement_type: fromDatatype.VarcharDatatypeInterface;
  shipping_config_json: ShippingConfigJsonTypeInterface;
}
